// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts"
// @generated from file gportal/api/support/v1/rpc.proto (package gportal.api.support.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CancelAddonPaymentRequest, ChargeAddonTicketRequest, CloseTicketRequest, CreateSupportMessageRequest, CreateTicketRequest, GetFinTokenRequest, GetTicketRequest, GetTicketsRequest, ListSupportInfosRequest, RateSupportMessageRequest } from "./requests_pb.js";
import { CancelAddonPaymentResponse, ChargeAddonTicketResponse, CloseTicketResponse, CreateSupportMessageResponse, CreateTicketResponse, GetFinTokenResponse, GetTicketResponse, GetTicketsResponse, ListSupportInfosResponse, RateSupportMessageResponse } from "./responses_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service gportal.api.support.v1.SupportService
 */
export const SupportService = {
  typeName: "gportal.api.support.v1.SupportService",
  methods: {
    /**
     * Creates a new support ticket.
     *
     * @generated from rpc gportal.api.support.v1.SupportService.CreateTicket
     */
    createTicket: {
      name: "CreateTicket",
      I: CreateTicketRequest,
      O: CreateTicketResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Adds a new message to an existing support ticket.
     *
     * @generated from rpc gportal.api.support.v1.SupportService.CreateSupportMessage
     */
    createSupportMessage: {
      name: "CreateSupportMessage",
      I: CreateSupportMessageRequest,
      O: CreateSupportMessageResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Retrieves details of a specific support ticket by its ID.
     *
     * @generated from rpc gportal.api.support.v1.SupportService.GetTicket
     */
    getTicket: {
      name: "GetTicket",
      I: GetTicketRequest,
      O: GetTicketResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Retrieves a list of all support tickets associated with the authenticated user.
     *
     * @generated from rpc gportal.api.support.v1.SupportService.GetTickets
     */
    getTickets: {
      name: "GetTickets",
      I: GetTicketsRequest,
      O: GetTicketsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Lists available support categories, user's servers, and addons for ticket creation.
     *
     * @generated from rpc gportal.api.support.v1.SupportService.ListSupportInfos
     */
    listSupportInfos: {
      name: "ListSupportInfos",
      I: ListSupportInfosRequest,
      O: ListSupportInfosResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Close a support ticket
     *
     * @generated from rpc gportal.api.support.v1.SupportService.CloseTicket
     */
    closeTicket: {
      name: "CloseTicket",
      I: CloseTicketRequest,
      O: CloseTicketResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Rates a support message
     *
     * @generated from rpc gportal.api.support.v1.SupportService.RateSupportMessage
     */
    rateSupportMessage: {
      name: "RateSupportMessage",
      I: RateSupportMessageRequest,
      O: RateSupportMessageResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Charge an addon support ticket
     *
     * @generated from rpc gportal.api.support.v1.SupportService.ChargeAddonTicket
     */
    chargeAddonTicket: {
      name: "ChargeAddonTicket",
      I: ChargeAddonTicketRequest,
      O: ChargeAddonTicketResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns a signed JWT token for Intercom Fin authentication.
     *
     * @generated from rpc gportal.api.support.v1.SupportService.GetFinToken
     */
    getFinToken: {
      name: "GetFinToken",
      I: GetFinTokenRequest,
      O: GetFinTokenResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Cancel an addon payment
     *
     * @generated from rpc gportal.api.support.v1.SupportService.CancelAddonPayment
     */
    cancelAddonPayment: {
      name: "CancelAddonPayment",
      I: CancelAddonPaymentRequest,
      O: CancelAddonPaymentResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

